export default {"src":"/_next/static/media/nightsky.1a18e15e.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};